// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"afe70b14","72":"e1e92bed","111":"fc033488","133":"a05f87f2","338":"86b188cb","339":"5d5ba355","360":"3abd70ec","402":"4e9ec18c","439":"0f93ffbb","492":"43abc0d2","514":"574827ca","516":"1373f751","573":"92dbe922","928":"dffbcabe"}[chunkId] + ".chunk.js";
};